import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'

export const Container = styled.div`
  padding: 0 60px 0 0;
`
export const ComanyDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const CommonFlex = styled(Flex)`
  margin-top: 25px;
  width: ${props => (props?.width ? props?.width : '100%')};
`
export const RightSection = styled.div`
  width: 60%;
`
export const SubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const AuthorityDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: #4d566e;
`
export const AuthSubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: #999fac;
`

export const TextVerified = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #5db594;
  margin: 0 25px 0 7px;
`
export const ImageSpan = styled.span`
  margin: 0 5px;
`
export const AuthoFlex = styled(Flex)`
  gap: 10px;
`
export const FlexAuth = styled(Flex)`
  width: 100%;
`
export const MainWrapper = styled.div`
  padding-right: 15%;
  ${props => props?.marginBottom && `margin-bottom: ${props?.marginBottom}`}
`
export const PopoverImg = styled.embed`
  border-radius: 4.45455px;
  width: 400px;
  height: 250px;
`
export const PreviewDiv = styled.div`
  cursor: pointer;
  margin-right: 10px;
`
export const DownLoadDiv = styled.a`
  cursor: pointer;
`
